import React, { ReactNode, Suspense, useEffect, useState } from "react";
import { useCurrentBrand } from "../../configurator/ConfigLoader";
//import { CURRENT_BRAND } from "../../App";

interface BrandComponentOptions {
    componentName: string;
    brand?: string;
    parameter?: any;
    basePath?: string;
    children?: ReactNode
}

/**
 * This component performs a lazy loading of components based on the current brand. It
 * accepts an input of type ```BrandComponentOptions``` with the following parameters:
 * 
 * - ```componentName```: the name of the component to load, passed as string
 * - ```brand``` (_optional_): the name of the brand that you want to use, in case
 * you need to load the component (and style) of another brand different from the current one
 * - ```parameter``` (_optional_): the object containing all of the parameters that you want to pass to the
 * loaded component
 * - ```basePath``` (_optional_): the base path of the folder where the component is located. The default
 * value is ```src/components```
 * - ```children``` (_optional_): any content that should be displayed as a children of the loaded component
 * 
 * 
 * For details about this lazy loading, please refer to the **Project structure** section
 * of the main documentation page.
 */
export function BrandComponent(props: BrandComponentOptions) {

    const [Comp, setComp] = useState(null);

    const currentBrand= useCurrentBrand();
    /*const BrandedComponent = React.lazy(() => {
        const brand = props.brand || CURRENT_BRAND;
        if (!brand) {
            return import('../' + props.componentName + '/component').then((comp) => ({ default: comp[props.componentName] }));
        }
        return import('../' + props.componentName + '/' + brand + '.component')
            .then((comp) => ({ default: comp[props.componentName] }))
            .catch(() => import('../' + props.componentName + '/component').then((comp) => ({ default: comp[props.componentName] })))
    });*/


    useEffect(() => {

            setComp(React.lazy(() => {
                const brand = props.brand || currentBrand;
                if (!brand) {
                    return import('../' + props.componentName + '/component').then((comp) => ({ default: comp[props.componentName] }));
                }
                return import('../' + props.componentName + '/' + brand + '.component')
                    .then((comp) => ({ default: comp[props.componentName] }))
                    .catch(() => import('../' + props.componentName + '/component').then((comp) => ({ default: comp[props.componentName] })))
            }))

    }, [currentBrand])

    return <Suspense fallback={null/*<p>Loading brand compoenent {props.componentName}</p>*/}>
        {Comp && <Comp {...props.parameter}>
            {props.children}
        </Comp>
        }
    </Suspense>
}